const getEnv = (key) =>  window.__ENV__?.[key] ?? process.env[key] ?? window.process?.env?.[key] ?? null;

const env = {
  REACT_APP_BACKEND_URL: getEnv("REACT_APP_BACKEND_URL"),
  REACT_APP_GOOGLE_API_KEY: getEnv("REACT_APP_GOOGLE_API_KEY"),
  REACT_APP_MAP_ID: getEnv("REACT_APP_MAP_ID"),
};

export default env;